module.exports = __webpack_public_path__ + "static/media/cwb-checked.6b9a360c.svg";